import { api } from '../api'
import {
  LoginResponse,
  LoginPayload,
  changePasswordPayload,
  ChangePasswordResponse,
} from './types'

const endpoint = {
  login: 'admin-login',
  logout: 'logout',
  changePassword: 'change-password',
}

export const login = async (params: LoginPayload): Promise<LoginResponse> => {
  const response = await api.auth.post(endpoint.login, {
    ...params,
  })

  return response.data
}

export const changePassword = async (
  params: changePasswordPayload
): Promise<ChangePasswordResponse> => {
  const response = await api.baseEndPoint.post(endpoint.changePassword, {
    ...params,
  })
  return response.data
}
